import { Box, Card, LinearProgress, Typography } from '@mui/material'
import { AnalyticsIcon, CorrectIcon, IncorrectIcon } from 'src/v3/core/icons'

type AssignmentMetricsProps = {
  totalAssignments: number
  overallCompletionRate: number
  completedAssignments: number
  overdueAssignments: number
}

export default function AssignmentMetrics({
  totalAssignments,
  overallCompletionRate,
  completedAssignments,
  overdueAssignments,
}: AssignmentMetricsProps) {
  let cardWrapperStyles = {
    bgcolor: 'background.paper',
    p: 3,
    textAlign: 'center',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  }

  let cardInnerStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    mb: 1,
  }

  let iconStyles = {
    borderRadius: 2,
    p: 1,
    mr: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }

  return (
    <Box className="grid grid-cols-1 gap-6 mb-6 sm:grid-cols-2 md:grid-cols-4">
      <Card sx={cardWrapperStyles}>
        <Box sx={cardInnerStyles}>
          <Box
            sx={{
              bgcolor: 'primary.main',
              ...iconStyles,
            }}
          >
            <AnalyticsIcon sx={{ color: 'white', fontSize: 20 }} />
          </Box>
          <Typography variant="h4" color="primary.main">
            {totalAssignments}
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary">
          Total Assignments
        </Typography>
      </Card>

      <Card sx={cardWrapperStyles}>
        <Box sx={cardInnerStyles}>
          <Box
            sx={{
              bgcolor: 'primary.main',
              ...iconStyles,
            }}
          >
            <AnalyticsIcon sx={{ color: 'white', fontSize: 20 }} />
          </Box>
          <Typography variant="h4" color="primary.main">
            {overallCompletionRate}%
          </Typography>
        </Box>
        <Typography
          variant="body2"
          color="text.secondary"
          id="avg-completion-label"
        >
          Avg Completion
        </Typography>
        <LinearProgress
          variant="determinate"
          value={overallCompletionRate}
          sx={{
            height: 8,
            borderRadius: 4,
            bgcolor: 'action.hover',
            mt: 2,
          }}
          aria-labelledby="avg-completion-label"
          aria-valuenow={overallCompletionRate}
          aria-valuemin={0}
          aria-valuemax={100}
        />
      </Card>

      <Card sx={cardWrapperStyles}>
        <Box sx={cardInnerStyles}>
          <Box
            sx={{
              bgcolor: 'success.main',
              ...iconStyles,
            }}
          >
            <CorrectIcon sx={{ color: 'white', fontSize: 20 }} />
          </Box>
          <Typography variant="h4" color="success.main">
            {completedAssignments}
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary">
          Completed
        </Typography>
      </Card>

      <Card sx={cardWrapperStyles}>
        <Box sx={cardInnerStyles}>
          <Box
            sx={{
              bgcolor: overdueAssignments > 0 ? 'error.main' : 'grey.400',
              ...iconStyles,
            }}
          >
            <IncorrectIcon sx={{ color: 'white', fontSize: 20 }} />
          </Box>
          <Typography
            variant="h4"
            color={overdueAssignments > 0 ? 'error.main' : 'text.secondary'}
          >
            {overdueAssignments}
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary">
          Overdue
        </Typography>
      </Card>
    </Box>
  )
}
